import { render, staticRenderFns } from "./InventoryPricingOld.vue?vue&type=template&id=9be7b11a&"
import script from "./InventoryPricingOld.vue?vue&type=script&lang=js&"
export * from "./InventoryPricingOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports